<template>
    <b-overlay :show="showoverlay" rounded="sm" class='demolistwrap'>
        <div class="card mt-0 border-0 bg-wash no-shadow demolistwrap2 geo">

            <div class="card-header px-0 bg-transparent border-0">

                <div class="col-md-12 px-0 row no-margin">
                       <!-- Abdullah26 chnaged this block -->
                    <div class="col-sm-6 d-flex align-items-center px-0">

                        <div class="align-self-center custom-search pr-0 mt-2 flex-grow-1" style="max-width: 480px;">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input type="search" placeholder="Search" v-model="search"
                                    @input="resetPagination()">
                                </b-form-input>
                            </b-input-group>
                        </div>

                        <div class="d-flex align-items-center mt-3 ml-2" style="height: 31px;">
                            <span
                                class="text-center px-2 border border-right-0 h-100 d-flex align-items-center employee-count-icon">
                                <b-icon icon="people-fill"></b-icon>
                            </span>

                            <span class="text-center px-2 border h-100 d-flex align-items-center employee-count-number"
                                style="min-width: 51px;">
                                {{ people }}
                            </span>

                        </div>

                    </div>
                     <!-- Abdullah26 chnaged this block upto this -->
                    <div class="col-sm-6 pr-0 d-flex flex-column align-items-end">

                        <!-- Count Box -->


                        <!-- Button -->
                        <div class="mt-2">
                            <b-button
                                id="filter_button"
                                class="employee-filter-btn mb-1 custom-secodary-btn btn-secondary collapsed"
                                v-b-toggle.sidebar_right
                            >
                                Filter
                                <b-icon class="ml-3" icon="funnel-fill"></b-icon>
                            </b-button>
                        </div>

                    </div>


                </div>


            </div>


            <div class="card-body px-0 container">

                <div class="employee-table-wrapper"
                    :class="[{ 'no-overflow': paginatedData.length < 8}, tableStickyHeight]">

                    <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table">

                        <thead>
                            <tr class="table-head ">
                                <td>
                                    <label class="custom-label" >
                                        <span>Employee Name</span>
                                    </label>
                                </td>
                                <td v-for="(location,n) in geolocations" >
                                    <label class="custom-label" >
                                        <span>{{ location }}</span>
                                    </label>
                                </td>



                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row">
                                <td class="strong">
                                    Assign All
                                </td>
                                <td class="cursor-pointer trz_relative" v-for="(location , i) in geolocations" :key="i">
                                    <b-form-checkbox :checked="isAllAssigned(i)" @change="assignLocationToAll(i)" class="checkbox-info"> <label class="custom-geolocation-label mb-0">{{ isAllAssigned(i) ? 'Unassign All' : 'Assign All' }}</label></b-form-checkbox>
                                </td>
                            </tr>

                            <tr class="hover-bg table-row" v-for="employee in paginatedData" :key="employee['employee_id']">
                                <td class="cursor-pointer trz_relative">
                                    {{ employee['name'] }}
                                </td>
                                <td class="cursor-pointer trz_relative" v-for="(location , i) in geolocations" :key="i">
                                    <b-form-checkbox v-model="mapping[employee['employee_id']][i]" @change="assignLocation(employee['employee_id'] , i)"></b-form-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <!-- grid view ends here -->
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                    @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>
                    </div>

                </div>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{ blankmsg }}</span>
                    <img v-if="showoverlay" v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                        width="100px" />
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <employee-filter :key="sidebar_key" :company_options="company_options"
                    :search_by_filter="search_by_filter"
                    v-on:childToParent="filterList"></employee-filter>
            </b-sidebar>

        </div>

    </b-overlay>
</template>


<script>
export default {

    data() {

        let sortOrders = {};


        return {

            columns: [],
            sortKey: 'name',
            sortOrders: sortOrders,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', nextbuttonstatus: 'true', prebuttonstatus: 'disabled' },
            search_by_filter: [],
            selected: [],
            sidebar_key: 0,
            selected_ids: [],
            showoverlay: true,
            blankmsg: 'Fetching data..',
            people: 0,
            search: '',
            length: 20,
            temp_length: 20,
            length_options: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            status_flag: false,
            show_loader: false,
            tableStickyHeight: '',
            employees:[],
            default_column:['name'],
            company_options:[],


            geolocations:[],
            mapping : [],
        }
    },
    methods: {


        filterList(value) {
            //console.log(value);
            this.resetPagination();
            if (value['reset'] == 1) {
                this.search_by_filter = value['search_by_filter'];
                $("#filter_button").click();

                //this.resetFlter();
            }
        },

        // sohel
        isAllAssigned(location_id) {
            return this.employees.every(employee => {
                return this.mapping[employee.employee_id] && this.mapping[employee.employee_id][location_id];
            });
        },
        // sohel

        assignLocationToAll : function(location_id)
        {
            let currentObj = this;

            let action = this.isAllAssigned(location_id) ? 'unassign' : 'assign'; // sohel

            let formData = new FormData();
            formData.append('location_id', location_id);
            formData.append('action', action); // sohel: send assign/unassign

            axios.post(this.$api_url+'/geolocation/mapemployee/all', formData)
                        .then(function (response)
                        {

                            this.getGeoLocationsMapping();

                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });


                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
        },

        assignLocation :function(employee_id , location_id)
        {
            let flg = 0;

            if(this.mapping[employee_id][location_id]) flg=1;
            let currentObj = this;

            let formData = new FormData();
            formData.append('employee_id', employee_id);
            formData.append('location_id', location_id);
            formData.append('flg', flg);

            axios.post(this.$api_url+'/geolocation/mapemployee/single', formData)
                        .then(function (response)
                        {


                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });


                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
        },

        //geolocation/list

        getGeoLocations: function () {

            let currentObj = this;
            axios.get(this.$api_url+'/geolocation/namelist' , {
                params: {

                }
            }).then(function(response){


                currentObj.geolocations = response.data;
            });
        },

        //geolocation/mapemployee/all
        getGeoLocationsMapping: function () {

            let currentObj = this;
            axios.get(this.$api_url+'/geolocation/mapemployee/all' , {
                params: {

                }
            }).then(function(response){


                currentObj.mapping = response.data;
            });
        },



        generateList: function () {

            let currentObj = this;
                axios.get(this.$api_url+'/employee/employee-list' , {
                    params: {

                    }
                }).then(function(response){
                    currentObj.showoverlay = false;
                    currentObj.employees = response.data.employee_data;
                    currentObj.company_options = response.data.options;


                    if (currentObj.employees.length > 0)
                    {
                        let cr = {};
                        cr['name'] = '';
                        cr['employee_code'] = '';
                        cr['jobposition_id'] = '';
                        cr['department_id'] = '';
                        cr['branch_id'] = '';

                        currentObj.search_by_filter = cr;
                        if (currentObj.employees.length == 0) {
                            currentObj.blankmsg = "Looks like there is no relevent data here.";
                            currentObj.show_loader = false;
                        }
                        else {
                            currentObj.tableStickyHeight = 'table-sticky-height';
                            currentObj.length_options = [{ value: 20, text: "20" },
                            { value: 50, text: "50" },
                            { value: 100, text: "100" }
                            ];
                            currentObj.people = currentObj.employees.length;

                        }

                    }
                    else {
                        currentObj.blankmsg = "Looks like there is no relevent data here.";
                        currentObj.show_loader = false;
                    }
            });


        },

    },
    created: function () {

        this.getGeoLocationsMapping();
        this.getGeoLocations();

        this.generateList();



        $(window).on('load', function (e) {
            setTimeout(function () {
                $('.div1').width($('table.employee-list-table').width());
                $('.div2').width($('table.employee-list-table').width());
                if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                    //alert($('table.employee-list-table').width());
                    $('.wrapper1').show();
                } else {
                    //alert('Its not bigger');
                    $('.wrapper1').hide();
                }
            }, 2000);
            $('.wrapper1').on('scroll', function (e) {
                $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
            });
            $('.wrapper2').on('scroll', function (e) {
                $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
            });

            $(document).on("click", ".trz-custom-dropdown .custom-switch input", function () {
                setTimeout(function () {
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                        $('.wrapper1').show();
                    } else {
                        $('.wrapper1').hide();
                    }
                }, 500);
            });
        });

    },
    computed:
    {
        filteredData() {


            let filtered_list = this.employees;

            let search_by_custom_fields = this.search_by_filter;

            var search_terms = new Array();

            Object.keys(search_by_custom_fields).forEach(key => {

                if (search_by_custom_fields[key] != '' ) {
                    search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                }
                else {
                    this.search_by_filter[key] = '';
                }


                /* issue

                if(this.status_flag)
                {
                    search_terms.push('status:Active');
                }

                */
            });

            //console.log(search_terms);

            if (search_terms.length > 0) {


                for (var i = 0; i < search_terms.length; i++) {
                    const term_to_search = search_terms[i].split(":");
                    let search_key = term_to_search[0];
                    let search_value = term_to_search[1];

                    if (search_key == 'status') {
                        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) == 0; }) });
                    }
                    else {
                        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1; }) });
                    }

                }
                //console.log(filtered_list.length);

                this.pagination.currentPage = 1;
                if (filtered_list.length == 0) {

                    this.blankmsg = "Nothing found.";
                }

            }


            if (this.search) {



                filtered_list = filtered_list.filter((row) => {

                return Object.keys(row).some((key) => {

                    if (key == 'name' || key == 'employee_code' || key == 'email' || key == 'jobposition' || key == 'branch' || key == 'department') {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    }

                })
                });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }


            this.people = filtered_list.length;
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

    }
}
</script>
<style scoped>
.checkbox-info  .custom-control-input{
  background-color: #5bc0de !important;
  border-color: #5bc0de !important;
}

.employee-list-table tr td:last-child {
    padding-right: 20px;
}

.action_thead {
    text-align: right;
}

.trz_disable_box+label::before {
    background: #adb5bdab !important;
}

.trz_people_btn.trz_email {
    right: 0;
    top: -185px;
}

.trz_employee_draft_edit {
    position: absolute;
    left: 12px;
    top: 18px;
}

.trz_relative {
    position: relative;
}</style>
